import type {
  FilterColumnType,
  GridColumnInfo,
  GridFilterOperator,
} from '../types'

export const LOGIC_OPTIONS = [
  { value: 'and', label: 'z.table.logic.and' },
  { value: 'or', label: 'z.table.logic.or' },
] as const

const TEXT_OPERATORS: Array<{ value: GridFilterOperator; label: string }> = [
  { value: 'eq', label: 'z.table.operator.eq' },
  { value: 'ne', label: 'z.table.operator.ne' },
  { value: 'like', label: 'z.table.operator.like' },
  { value: 'notLike', label: 'z.table.operator.notLike' },
  { value: 'empty', label: 'z.table.operator.empty' },
  { value: 'notEmpty', label: 'z.table.operator.notEmpty' },
]

const NUMBER_DATE_OPERATORS: Array<{
  value: GridFilterOperator
  label: string
}> = [
  { value: 'eq', label: 'z.table.operator.eq' },
  { value: 'ne', label: 'z.table.operator.ne' },
  { value: 'gt', label: 'z.table.operator.gt' },
  { value: 'ge', label: 'z.table.operator.ge' },
  { value: 'lt', label: 'z.table.operator.lt' },
  { value: 'le', label: 'z.table.operator.le' },
  { value: 'empty', label: 'z.table.operator.empty' },
  { value: 'notEmpty', label: 'z.table.operator.notEmpty' },
]

export function resolveDefaultFilterOperator(
  type: FilterColumnType,
  column?: Pick<GridColumnInfo, 'filterDefaultOperator'>
): GridFilterOperator {
  const custom = column?.filterDefaultOperator
  if (custom) {
    const allowed = getOperator(type).map((item) => item.value)
    if (allowed.includes(custom)) {
      return custom
    }
  }
  if (
    type === 'number' ||
    type === 'date' ||
    type === 'datetime' ||
    type === 'lov' ||
    type === 'table'
  ) {
    return 'eq'
  }
  return 'like'
}

export function getOperator(
  type: string
): Array<{ value: GridFilterOperator; label: string }> {
  if (type === 'number' || type === 'date' || type === 'datetime') {
    return NUMBER_DATE_OPERATORS.map((item) => ({ ...item }))
  }
  return TEXT_OPERATORS.map((item) => ({ ...item }))
}

export function resolveFilterColumnType(type: string): FilterColumnType {
  const allowed = new Set([
    'input',
    'lov',
    'table',
    'html',
    'base',
    'date',
    'datetime',
    'number',
  ])
  if (allowed.has(type)) {
    return type as FilterColumnType
  }
  return 'input'
}
